import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-right',
  templateUrl: './no-right.component.html',
  styleUrls: ['./no-right.component.css']
})
export class NoRightComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
